"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchStatusEvent = void 0;
class LaunchStatusEvent {
}
exports.LaunchStatusEvent = LaunchStatusEvent;
//# sourceMappingURL=LaunchStatusEvent.js.map